import type { VaultProperty } from '../../../entities/VaultProperty';
import { magellanClient } from '../../../infra/axios';
import type {
  CreateVaultPropertyRequestDTO,
  CreateVaultPropertyResponseDTO,
  GetVaultPropertiesResponseDTO,
  UpdateVaultPropertyRequestDTO,
  UpdateVaultPropertyResponseDTO,
} from './dto';

export async function createVaultProperties(
  payload: CreateVaultPropertyRequestDTO,
): Promise<CreateVaultPropertyResponseDTO> {
  const response = await magellanClient.post<CreateVaultPropertyResponseDTO>(
    `/vaultProperties`,
    payload,
  );

  return response.data;
}

export async function getVaultProperties(): Promise<VaultProperty[]> {
  const response =
    await magellanClient.get<GetVaultPropertiesResponseDTO>(`/vaultProperties`);

  return response.data.vaultProperties;
}

export async function getVaultProperty(
  vaultPropertyId: number,
): Promise<VaultProperty> {
  const response = await magellanClient.get<VaultProperty>(
    `/vaultProperties/${vaultPropertyId}`,
  );

  return response.data;
}

export async function updateVaultProperty(
  vaultPropertyId: number,
  payload: UpdateVaultPropertyRequestDTO,
  withTagsInference = false,
): Promise<UpdateVaultPropertyResponseDTO> {
  const endpoint = withTagsInference
    ? `/vaultProperties/${vaultPropertyId}/infer-tags`
    : `/vaultProperties/${vaultPropertyId}`;
  const response = await magellanClient.put<UpdateVaultPropertyResponseDTO>(
    endpoint,
    payload,
  );

  return response.data;
}

export async function deleteVaultProperty(
  vaultPropertyId: number,
): Promise<void> {
  await magellanClient.delete(`/vaultProperties/${vaultPropertyId}`);
}
